(function () {
  'use strict';

  if (customElements.get('zoom-images')) return;

  customElements.define('zoom-images', class extends HTMLElement {
    constructor() {
      super();
      this.mediaContainer = this.closest('[data-product-single-media-group]');
      this.slider = this.mediaContainer?.querySelector('[data-product-single-media-slider]');
      this.zoomWrappers = this.mediaContainer?.querySelectorAll('[data-zoom-wrapper]');
      this.a11y = window.theme.a11y;
      this.activeTouchPointers = new Set();
      this.pinching = false;
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerEnd = this.handlePointerEnd.bind(this);
      this.handleTouchEnd = this.handleTouchEnd.bind(this);
    }

    connectedCallback() {
      this.enablePinchZoom();

      if (!this.zoomWrappers.length) return;

      this.zoomWrappers.forEach((zoomWrapper, index) => {
        zoomWrapper.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.slider?.classList.contains('is-moving')) return;

          this.a11y.state.trigger = zoomWrapper;
          this.createZoom(index);
        });
      });
    }

    disconnectedCallback() {
      if (!this.slider) return;

      this.slider.removeEventListener('pointerdown', this.handlePointerDown, true);
      this.slider.removeEventListener('pointermove', this.handlePointerMove, true);
      this.slider.removeEventListener('pointerup', this.handlePointerEnd, true);
      this.slider.removeEventListener('pointercancel', this.handlePointerEnd, true);
      this.slider.removeEventListener('touchend', this.handleTouchEnd, true);
    }

    enablePinchZoom() {
      if (!this.slider || !window.PointerEvent) return;

      this.slider.addEventListener('pointerdown', this.handlePointerDown, true);
      this.slider.addEventListener('pointermove', this.handlePointerMove, true);
      this.slider.addEventListener('pointerup', this.handlePointerEnd, true);
      this.slider.addEventListener('pointercancel', this.handlePointerEnd, true);
      this.slider.addEventListener('touchend', this.handleTouchEnd, true);
    }

    handlePointerDown(event) {
      if (event.pointerType !== 'touch') return;

      this.activeTouchPointers.add(event.pointerId);
      if (this.activeTouchPointers.size < 2) return;

      this.pinching = true;
      window.theme.Flickity.data(this.slider)?.pointerDone();
      event.stopImmediatePropagation();
    }

    handlePointerMove(event) {
      if (this.pinching && event.pointerType === 'touch') {
        event.stopImmediatePropagation();
      }
    }

    handlePointerEnd(event) {
      if (event.pointerType !== 'touch') return;

      if (this.pinching) event.stopImmediatePropagation();
      this.activeTouchPointers.delete(event.pointerId);
      if (this.activeTouchPointers.size === 0) this.pinching = false;
    }

    handleTouchEnd(event) {
      if (event.touches.length !== 0) return;

      this.activeTouchPointers.clear();
      this.pinching = false;
    }

    createZoom(index) {
      const items = [];

      this.zoomWrappers.forEach((zoomWrapper) => {
        const src = zoomWrapper.getAttribute('href');
        items.push({
          src,
          w: parseInt(zoomWrapper.getAttribute('data-image-width')),
          h: parseInt(zoomWrapper.getAttribute('data-image-height')),
          msrc: src,
        });
      });

      let mainClass = 'pswp-zoom-gallery';
      if (items.length === 1) mainClass += ' pswp-zoom-gallery--single';

      const options = {
        barsSize: { top: 60, bottom: 60 },
        history: false,
        focus: false,
        index,
        mainClass,
        showHideOpacity: true,
        showAnimationDuration: 250,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        captionEl: false,
        closeEl: true,
        closeElClasses: ['caption-close'],
        tapToClose: false,
        clickToCloseNonZoomable: false,
        maxSpreadZoom: 2,
        loop: false,
        spacing: 0,
        allowPanToNext: true,
        pinchToClose: false,
      };

      new window.theme.LoadPhotoswipe(items, options);
    }
  });
}());
